export default __webpack_public_path__ + "static/media/Johto.5b8942fc.jpg";